import classNames from "classnames";
import React from "react";
import styles from "./SiteCallout.scss";

/**
 * Tinted call-to-action panel on a public page: title and text on the left, actions on the right
 * @param actions – buttons; size them with the m-frontCta mixin
 */
export const SiteCallout = ({ title, text, actions, className }) => {
    return (
        <section className={classNames(styles.base, className)}>
            <div className={styles.copy}>
                <h2 className={styles.title}>{title}</h2>
                {text ? <p className={styles.text}>{text}</p> : null}
            </div>
            {actions ? <div className={styles.actions}>{actions}</div> : null}
        </section>
    );
};
